import fetch from "@lib/fetch";

import { reactQueryInfiniteFetcherAdapter } from "../reactQueryFetcherAdapters";
import type { AuthenticationCredentialsResult, AuthenticationCredentialSurface } from "./types";

export const getAuthenticationCredentials = reactQueryInfiniteFetcherAdapter(
  "/app_settings/authentication_credentials",
  (
    signal: AbortSignal,
    [appGroupId, domain, surface, search]: [string, string, AuthenticationCredentialSurface, string],
    start: number | undefined
  ): Promise<AuthenticationCredentialsResult> =>
    fetch(
      "/app_settings/authentication_credentials",
      "GET",
      {
        app_group_id: appGroupId,
        domain,
        surface,
        limit: 100,
        start: start ?? 0,
        ...(search ? { query: { 0: { key: "", value: search } } } : {}),
      },
      { signal },
      { propagateFetchRequestError: false }
    )
);
